import { marked } from "marked";
import { Tokens } from "./tokens";
import { FC } from "react";
import { DefaultRenderers, RendererProps } from "./renderers";
import { emojiTokenizer } from "./emoji";
import { mentionTokenizer } from "./mention";

const tokenizer = {
  code(src: string) {
    // Marked's default tokenizer doesn't parse code blocks correctly.

  }
}

interface IProps {
  text: string;
  renderers?: { [key: string]: FC<RendererProps> };
}

export function Markdown({ text, renderers = DefaultRenderers }: IProps) {
  text = text.replace(/^https?:\/\/tenor\.com\/view\/[^\b]+$/, "");
  let tokens = marked.use({ gfm: true, breaks: true, extensions: [emojiTokenizer, mentionTokenizer] }).lexer(text ?? "");

  return (
    <Tokens tokens={tokens} renderers={renderers} />
  );
}
